import {
    combineReducers
} from "redux";

import registerReducer from '../slices/register';
import loginReducer from '../slices/login';
import logoutReducer from '../slices/logout';
import loginSendOtpReducer from "../slices/loginSendOtp";
import verifyOtpReducer from "../slices/verifyOtp";
import forgotPasswordReducer from "../slices/forgotPassword";
import resetPasswordReducer from "../slices/resetPassword";
import postMachineReducer from "../slices/postMachineCreation";
import getMachineReducer from "../slices/getMachine";
import rawMaterialMachineMappingReducer from "../slices/postMachineAndRawMaterialMapping";
import getRawMaterialsReducer from "../slices/getRawMaterials";
import createRawMaterialReducer from "../slices/createRawMaterial";
import postCreateAdminReducer from "../slices/createAdmin";
import getAllAdminsReducer from "../slices/getAllAdmins";
import updateAdminReducer from "../slices/UpdateAdmin";
import deleteAdminReducer from "../slices/DeleteAdmin";
import getMachineByIdReducer from "../slices/getMachineByID";
import editRawMaterialReducer from "../slices/editRawMaterial";
import deleteRawMaterialReducer from "../slices/deleteRawMaterial";
import getUserReducer from "../slices/getUsers";
import createUserReducer from "../slices/createUser";
import editUserReducer from "../slices/editUser";
import adminDashboardReducer from "../slices/adminDashboard";
import putRawMaterialMachineMappingReducer from "../slices/editMachineAndRawMaterialMapping";
import getRawMaterialMachineMappingReducer from "../slices/getMachineAndRawMaterialMapping";
import profileReducer from "../slices/profile";
import updateProfileReducer from "../slices/updateProfile";
import createOrderReducer from "../slices/createOrder";
import getOrderReducer from "../slices/getOrder";
import updateOrderReducer from "../slices/updateOrder";
import deleteOrderReducer from "../slices/deleteOrder";
import prUpdateOrderReducer from "../slices/prUpdateOrder";
import prDashboardReducer from "../slices/prDashboard";
import prGetOrderReducer from "../slices/prGetOrder";
import deleteRawMaterialMachineMappingReducer from "../slices/deleteMachineAndRawMaterialMapping";
import getProductionTrackingReducer from "../slices/getProductionTracking";
import getStockReducer from "../slices/getStockManagement";
import editStockReducer from "../slices/editStockManagement";
import createDamageReportReducer from "../slices/createDamageReport";
import getDamageReportReducer from "../slices/getDamageReport";
import editDamageReportReducer from "../slices/editDamageReport";
import getAdminDamageReportReducer from "../slices/getAdminDamageReport";
import editAdminDamageReportReducer from "../slices/editAdminDamageReport";
import updateSubscriptionReducer from "../slices/updateSubscription";
import getSuperAdminDashboardReducer from "../slices/superAdminDashboard" 
import recaluculateReducer from "../slices/recaluculate"
import RawMaterialHistoryReduce from "../slices/rawMaterialHistory"


export default combineReducers({
    registerReducer,
    loginReducer,
    logoutReducer,
    loginSendOtpReducer,
    verifyOtpReducer,
    forgotPasswordReducer,
    resetPasswordReducer,
    postMachineReducer,
    getMachineReducer,
    rawMaterialMachineMappingReducer,
    getRawMaterialsReducer,
    createRawMaterialReducer,
    postCreateAdminReducer,
    getAllAdminsReducer,
    updateAdminReducer,
    deleteAdminReducer,
    getMachineByIdReducer,
    editRawMaterialReducer,
    deleteRawMaterialReducer,
    getUserReducer,
    createUserReducer,
    editUserReducer,
    adminDashboardReducer,
    putRawMaterialMachineMappingReducer,
    getRawMaterialMachineMappingReducer,
    profileReducer,
    updateProfileReducer,
    createOrderReducer,
    getOrderReducer,
    updateOrderReducer,
    deleteOrderReducer,
    prUpdateOrderReducer,
    prDashboardReducer,
    prGetOrderReducer,
    deleteRawMaterialMachineMappingReducer,
    getProductionTrackingReducer,
    getStockReducer,
    editStockReducer,
    createDamageReportReducer,
    getDamageReportReducer,
    editDamageReportReducer,
    getAdminDamageReportReducer,
    editAdminDamageReportReducer,
    updateSubscriptionReducer,
    getSuperAdminDashboardReducer,
    recaluculateReducer,
    RawMaterialHistoryReduce
});